import { render, staticRenderFns } from "./userAgreementList.vue?vue&type=template&id=77e081a2&scoped=true&"
import script from "./userAgreementList.vue?vue&type=script&lang=js&"
export * from "./userAgreementList.vue?vue&type=script&lang=js&"
import style0 from "./userAgreementList.vue?vue&type=style&index=0&id=77e081a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e081a2",
  null
  
)

export default component.exports